'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _button = require('./global_components/button.js');

var _button2 = _interopRequireDefault(_button);

var _nav_chart = require('./charts/nav_chart');

var _nav_chart2 = _interopRequireDefault(_nav_chart);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _moment = require('moment/moment');

var _moment2 = _interopRequireDefault(_moment);

var _ramda = require('ramda');

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

require('airbnb-js-shims');

var _single_date_picker_wrapper = require('./global_components/single_date_picker_wrapper');

var _single_date_picker_wrapper2 = _interopRequireDefault(_single_date_picker_wrapper);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _date_range_dropdown = require('./global_components/date_range_dropdown');

var _date_range_dropdown2 = _interopRequireDefault(_date_range_dropdown);

var _click_or_escape_outside = require('./click_or_escape_outside');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _legendSquare = require('./charts/legendSquare');

var _date_formatter3 = require('common-utilities/src/date_formatter');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _chart_utility = require('../../../packages/common-utilities/src/chart_utility');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _constants = require('../../../packages/common-utilities/src/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setTooltipWrapper = function setTooltipWrapper(text) {
  return _react2.default.createElement(
    'span',
    { 'data-testid': 'tooltip-error',
      id: 'tooltip-error',
      className: 'caption font-light font-extreme-red' },
    text
  );
};
var subtractYears = function subtractYears(date, numberOfYears) {
  return (0, _moment2.default)(date).subtract(numberOfYears, "years").format(_date_formatter2.default.edpiDateFormat);
};
var getDateFromObject = function getDateFromObject(data) {
  var pathToDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "date";
  return (0, _ramda.path)([pathToDate], data);
};

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var NAVHistoryChartParent = function (_React$Component) {
  _inherits(NAVHistoryChartParent, _React$Component);

  function NAVHistoryChartParent(props) {
    _classCallCheck(this, NAVHistoryChartParent);

    var _this = _possibleConstructorReturn(this, (NAVHistoryChartParent.__proto__ || Object.getPrototypeOf(NAVHistoryChartParent)).call(this, props));

    _this.renderToolTipErrorMessage = function (elementId, errorKey) {
      var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var tooltipMessage = null;
      var values = {
        startDate: _date_formatter2.default.getLocalFormattedDate(getDateFromObject(_this.props.historicalNAVList[0])),
        endDate: _date_formatter2.default.getLocalFormattedDate(getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList)))
      };
      if (errorKey === 'pdp-historical-chart-error-message-out-of-range') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[4], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-prior-to-to-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[0], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-from-date-same-as-to-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[2], errorKey);
      } else if (errorKey === 'pdp-historical-chart-error-message-prior-to-from-Date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[1], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-to-date-same-as-from-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[3], errorKey);
      }
      tooltipMessage = setTooltipWrapper(tooltipMessage);
      var el = document.getElementById(elementId);
      var elHeight = el.offsetHeight;
      var elWidth = el.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var offsetArrowHeight = 4;
      var elPadding = 10;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var toolTipWidth = el.offsetWidth;

      var elOffset = (0, _ramda.mergeDeepRight)({
        top: elRect.top + docTop + arrowHeight + elHeight - offsetArrowHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - elPadding + (elRect.right - elRect.left) / 8,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipWidth,
        showCrossIcon: false
      }, additionalProps);

      _this.setState({
        error: "extreme",
        errorId: elementId
      });
      elementId === _this.props.id + '-from-date' ? _this.refs.from_dropdown_ref.handleOpen() : _this.refs.to_dropdown_ref.handleOpen();
      _this.props.tooltip.openTooltip(elOffset, null, tooltipMessage, false);
    };

    var fromDate = void 0;
    var toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList)), "YYYY-MM-DD"));
    var filteredData = (0, _functional_utility.isNilOrEmpty)(_this.props.historicalNAVList) ? _this.props.fundValuationHistory : _this.props.historicalNAVList;
    var dateRangeArray = _this.getDateRangeArray();
    var selectedDateOption = _this.getDefaultSelectedDateOption(dateRangeArray);
    var selectedDateOptionTranslateKey = _this.getDefaultSelectedDateOptionTranslationKey(dateRangeArray);
    var quarterlyDateRangeKeys = ["Q3", "Q2", "Q1", "PY"];
    var etfDefaultDateRangeSelectedItem = _this.getDefaultSelectionForETF(dateRangeArray);
    if (!(0, _functional_utility.isNilOrEmpty)(etfDefaultDateRangeSelectedItem) && (0, _ramda.includes)(etfDefaultDateRangeSelectedItem.value, quarterlyDateRangeKeys)) {
      var quarterFilteredData = (0, _ramda.filter)(function (node) {
        return node.periodTypeCode === etfDefaultDateRangeSelectedItem.value;
      }, _this.props.historicalNAVList);
      fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject(quarterFilteredData[0]), "YYYY-MM-DD"));
      toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(quarterFilteredData)), "YYYY-MM-DD"));
      filteredData = _this.setFilteredData(fromDate, toDate);
    } else if (_collection_utility.CollectionUtility.includes(_this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_ONE_MONTH_PERIOD')) {
      var lastNavDate = getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList));
      var oneMonth = (0, _moment2.default)(lastNavDate).subtract(1, 'months');
      for (var i = _this.props.historicalNAVList.length - 1; i > 0; i--) {
        if ((0, _moment2.default)(_this.props.historicalNAVList[i].date).isBefore(oneMonth)) {
          fromDate = (0, _moment2.default)(_this.props.historicalNAVList[i + 1].date);
          filteredData = _this.setFilteredData(fromDate, toDate);
          break;
        }
      }
      if ((0, _ramda.isNil)(fromDate)) {
        fromDate = (0, _moment2.default)(getDateFromObject(_this.props.historicalNAVList[0]));
        filteredData = _this.setFilteredData(fromDate, toDate);
      }
    } else if ((0, _ramda.and)(_collection_utility.CollectionUtility.includes(_this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_ONE_YEAR_PERIOD'), _this.isDataMoreThanAYear((0, _moment2.default)(getDateFromObject(_this.props.historicalNAVList[0])), toDate))) {
      var _lastNavDate = getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList));
      var oneYear = (0, _moment2.default)(_lastNavDate).subtract(1, 'years');
      for (var _i = _this.props.historicalNAVList.length - 1; _i >= 0; _i--) {
        if ((0, _moment2.default)(_this.props.historicalNAVList[_i].date).isBefore(oneYear)) {
          fromDate = (0, _moment2.default)(_this.props.historicalNAVList[_i + 1].date);
          filteredData = _this.setFilteredData(fromDate, toDate);
          break;
        }
      }
      if ((0, _ramda.isNil)(fromDate)) {
        fromDate = (0, _moment2.default)(getDateFromObject(_this.props.historicalNAVList[0]));
        filteredData = _this.setFilteredData(fromDate, toDate);
      }
    } else if (_collection_utility.CollectionUtility.includes(_this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_FIVE_YEAR_PERIOD')) {
      var _lastNavDate2 = getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList));
      var fiveYear = (0, _moment2.default)(_lastNavDate2).subtract(5, 'years');
      for (var _i2 = _this.props.historicalNAVList.length - 1; _i2 >= 0; _i2--) {
        if ((0, _moment2.default)(_this.props.historicalNAVList[_i2].date).isBefore(fiveYear)) {
          fromDate = (0, _moment2.default)(_this.props.historicalNAVList[_i2 + 1].date);
          filteredData = _this.setFilteredData(fromDate, toDate);
          break;
        }
      }
      if ((0, _ramda.isNil)(fromDate)) {
        fromDate = (0, _moment2.default)(getDateFromObject(_this.props.historicalNAVList[0]));
        filteredData = _this.setFilteredData(fromDate, toDate);
      }
    } else {
      fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject(_this.props.historicalNAVList[0]), "YYYY-MM-DD"));
      filteredData = _this.props.historicalNAVList;
    }

    _this.maxDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList)), "YYYY-MM-DD"));
    _this.minDate = (0, _moment2.default)((0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject(_this.props.historicalNAVList[0]), "YYYY-MM-DD")));

    _this.state = {
      fromDate: fromDate,
      validFromDate: fromDate,
      toDate: toDate,
      validToDate: toDate,
      filteredData: filteredData,
      errorMessage: '',
      count: 5,
      selectedDateOption: selectedDateOption,
      selectedDateOptionTranslateKey: selectedDateOptionTranslateKey
    };

    _this.renderCustomDatePickers = _this.renderCustomDatePickers.bind(_this);
    _this.breakpointIsBetweenOneAndThree = _this.breakpointIsBetweenOneAndThree.bind(_this);
    _this.renderNavHistoryCard = _this.renderNavHistoryCard.bind(_this);
    _this.renderToolTipErrorMessage = _this.renderToolTipErrorMessage.bind(_this);
    _this.resetErrorState = _this.resetErrorState.bind(_this);
    _this.onChangeFromDate = _this.onChangeFromDate.bind(_this);
    _this.onChangeToDate = _this.onChangeToDate.bind(_this);
    _this.setDateFilter = _this.setDateFilter.bind(_this);
    _this.dateRangeItems = _this.dateRangeItems.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.renderDateRangeDropdown = _this.renderDateRangeDropdown.bind(_this);
    _this.setCustomDateRangeDropdown = _this.setCustomDateRangeDropdown.bind(_this);
    _this.addYearMapsToDateRangeArray = _this.addYearMapsToDateRangeArray.bind(_this);

    _this['dropdown-label-dateRange'] = { 'text': '' };

    _this.errorMessages = ["From Date has to be less than to date.", "To Date cannot be less than from date", "From Date cannot be same as To date", "To Date cannot be same as From date", _this.defaultOutOfRangeErrorMessage()];
    return _this;
  }

  _createClass(NAVHistoryChartParent, [{
    key: 'getDefaultSelectionForETF',
    value: function getDefaultSelectionForETF(dateRangeArray) {
      var latestDateRangeItem = null;
      if (this.isETFHistoricalNAVMarketPriceChart()) {
        latestDateRangeItem = (0, _ramda.find)((0, _ramda.propEq)("value", "Q3"))(dateRangeArray);
        if ((0, _functional_utility.isNilOrEmpty)(latestDateRangeItem)) {
          latestDateRangeItem = (0, _ramda.find)((0, _ramda.propEq)("value", "Q2"))(dateRangeArray);
        }
        if ((0, _functional_utility.isNilOrEmpty)(latestDateRangeItem)) {
          latestDateRangeItem = (0, _ramda.find)((0, _ramda.propEq)("value", "Q1"))(dateRangeArray);
        }
        if ((0, _functional_utility.isNilOrEmpty)(latestDateRangeItem)) {
          latestDateRangeItem = (0, _ramda.find)((0, _ramda.propEq)("value", "PY"))(dateRangeArray);
        }
      }
      return latestDateRangeItem;
    }
  }, {
    key: 'getDefaultSelectedDateOption',
    value: function getDefaultSelectedDateOption(dateRangeArray) {
      var etfDefaultSelection = this.getDefaultSelectionForETF(dateRangeArray);
      if (!(0, _functional_utility.isNilOrEmpty)(etfDefaultSelection)) {
        return etfDefaultSelection.displayValue;
      }
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_FIVE_YEAR_PERIOD')) {
        return "Last 5 year";
      } else if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_SINCE_INCEPTION_PERIOD')) {
        return "Since Inception";
      }
      return this.props.fund.isShareClassMoreThanAnYearOld ? "Last 1 year" : "Since Inception";
    }
  }, {
    key: 'getDefaultSelectedDateOptionTranslationKey',
    value: function getDefaultSelectedDateOptionTranslationKey(dateRangeArray) {
      var etfDefaultSelection = this.getDefaultSelectionForETF(dateRangeArray);
      if (!(0, _functional_utility.isNilOrEmpty)(etfDefaultSelection)) {
        return etfDefaultSelection.translationKey;
      }
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_FIVE_YEAR_PERIOD')) {
        return "dropdown-last-5-years";
      } else if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_SINCE_INCEPTION_PERIOD')) {
        return "since-inception";
      }
      return this.props.fund.isShareClassMoreThanAnYearOld ? "dropdown-last-1-year" : "since-inception";
    }
  }, {
    key: 'setCustomDateRangeDropdown',
    value: function setCustomDateRangeDropdown() {
      this['dropdown-label-dateRange'].text = 'Custom Date Range';

      this.setState({
        selectedDateOption: 'Custom Date Range',
        selectedDateOptionTranslateKey: 'dropdown-custom-date-range',
        selectedDateOptionValue: 'custom'
      });
    }
  }, {
    key: 'defaultOutOfRangeErrorMessage',
    value: function defaultOutOfRangeErrorMessage() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.historicalNAVList)) {
        return "Please enter a date within the date range";
      }
      return "Please enter a date within the date range " + getDateFromObject(this.props.historicalNAVList[0]) + " - " + getDateFromObject((0, _ramda.last)(this.props.historicalNAVList)) + ".";
    }
  }, {
    key: 'isDataMoreThanAYear',
    value: function isDataMoreThanAYear(fromDate, toDate) {
      var rangeOfMonth = toDate.diff(fromDate, "months", true);
      return rangeOfMonth >= 12;
    }
  }, {
    key: 'setRef',
    value: function setRef(refId) {
      var _this2 = this;

      return function (el) {
        return _this2[refId] = el;
      };
    }
  }, {
    key: 'getNav',
    value: function getNav(o) {
      return this.props.dataPointKey === 'navPrice' ? o.navPrice : o.marketBasedNAVPrice;
    }
  }, {
    key: 'getYAxisTicks',
    value: function getYAxisTicks() {
      if (this.isDistributingVNAV()) {
        return [0.9970, 0.9975, 0.9980, 0.9985, 0.9990, 0.9995, 1.0000, 1.0005, 1.0010, 1.0015, 1.0020, 1.0025];
      } else if (this.isDistributingLVNAVOrCNAV()) {
        return [0.9980, 0.9985, 0.9990, 0.9995, 1.0000, 1.0005, 1.0010, 1.0015, 1.0020];
      }

      var arr = [];
      var data = (0, _ramda.isNil)(this.state.filteredData) ? this.props.historicalNAVList : this.state.filteredData;
      if ((0, _ramda.isNil)(data) || data.length === 0) {
        return arr;
      }

      var sortedData = (0, _ramda.sortBy)((0, _ramda.prop)(this.props.dataPointKey === 'navPrice' ? "navPrice" : "marketBasedNAVPrice"))(data);
      var maxTick = sortedData[sortedData.length - 1];
      var minTick = sortedData[0];

      var shouldShowCurrencyOnYAxis = (0, _ramda.and)(!(0, _functional_utility.isNilOrEmpty)(this.props.fund.visibleData.visibleDataPoints), _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HISTORICAL_CHART_Y_AXIS_CURRENCY'));
      var isETFHistoricalNAVMarketPriceChart = this.isETFHistoricalNAVMarketPriceChart();
      if ((0, _ramda.or)(!shouldShowCurrencyOnYAxis, isETFHistoricalNAVMarketPriceChart)) {
        arr = this.getYAxisArrayByNearestRounding(maxTick, minTick, isETFHistoricalNAVMarketPriceChart, data);
      } else if (!(0, _functional_utility.isNilOrEmpty)(this.props.fund.visibleData.visibleDataPoints) && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HISTORICAL_CHART_Y_AXIS_ORIGINAL')) {
        arr = this.getYAxisArray(maxTick, minTick);
      } else {
        arr = this.getYAxisArrayByNearestRounding(maxTick, minTick, false, null);
      }

      return arr;
    }
  }, {
    key: 'getYAxisArrayByNearestRounding',
    value: function getYAxisArrayByNearestRounding(maxTick, minTick, isETFHistoricalNAVMarketPriceChart, dataForETF) {
      var intervals = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 8;

      var arr = [];
      var noZeroDP = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_YAXIS_ZERO_DP');
      var diffInInterval = (this.getNav(maxTick) - this.getNav(minTick)) / (intervals - 1);
      var nearestRounding = _chart_utility2.default.getNearestRounding(diffInInterval, 1, noZeroDP);

      var maxYTick = Math.ceil(this.getNav(maxTick) / nearestRounding) * nearestRounding;
      var minYTick = Math.floor(this.getNav(minTick) / nearestRounding) * nearestRounding;

      if (noZeroDP) {
        maxYTick = Math.ceil(maxYTick);
        minYTick = Math.floor(minYTick);
      }

      if (isETFHistoricalNAVMarketPriceChart) {
        var sortedMarketPrice = (0, _ramda.sortBy)((0, _ramda.prop)('marketValueNavPrice'))(dataForETF);
        if (maxYTick < sortedMarketPrice[sortedMarketPrice.length - 1].marketValueNavPrice) {
          maxYTick = Math.ceil(sortedMarketPrice[sortedMarketPrice.length - 1].marketValueNavPrice / nearestRounding) * nearestRounding;
        }
        if (minYTick > sortedMarketPrice[0].marketValueNavPrice) {
          minYTick = Math.floor(sortedMarketPrice[0].marketValueNavPrice / nearestRounding) * nearestRounding;
        }
      }

      var steps = Math.ceil((maxYTick - minYTick) / intervals / nearestRounding) * nearestRounding;
      var val = minYTick;
      for (var i = 0; (0, _ramda.or)(i < intervals, val < maxYTick); i++) {
        val = minYTick + i * steps;
        if (val <= maxYTick) {
          arr.push(val);
        }
      }

      if (arr.length < 5) {
        arr.push(arr[arr.length - 1] + steps);
        if (arr[0] - steps > 0) {
          arr.unshift(arr[0] - steps);
        }
      }

      return arr;
    }
  }, {
    key: 'getYAxisArray',
    value: function getYAxisArray(maxTick, minTick) {
      var arr = [];
      var multiplier = 10;

      var maxYTick = this.getNav(maxTick) + this.getNav(maxTick) / 10;
      var minYTick = this.getNav(minTick) - this.getNav(minTick) / 10;

      var part = (maxYTick - minYTick) / 7;
      if (part < 10) {
        part = 10;
      } else {
        part = Math.round(part / multiplier) * multiplier;
      }
      if (part >= 100) {
        multiplier = 100;
      }
      part = Math.ceil(part / multiplier) * multiplier;
      minYTick = Math.floor(minYTick / multiplier) * multiplier;

      if (minYTick <= 30 && part === 10 || minYTick - part < 0) {
        var tick = 0;
        arr.push(tick);
        for (var i = 1; i < 10; i++) {
          tick += part;
          arr.push(tick);
        }
      } else {
        var val = minYTick;
        arr.push(minYTick - part);
        arr.push(minYTick);
        for (var _i3 = 0; (0, _ramda.or)(_i3 < 7, val < maxYTick); _i3++) {
          val += part;
          arr.push(val);
        }
      }
      return arr;
    }
  }, {
    key: 'isETFHistoricalNAVMarketPriceChart',
    value: function isETFHistoricalNAVMarketPriceChart() {
      return _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, 'ETF_HISTORICAL_NAV_MARKET_PRICE');
    }
  }, {
    key: 'isETFHistoricalNAVPriceChart',
    value: function isETFHistoricalNAVPriceChart() {
      return _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, 'ETF_HISTORICAL_NAV_PRICE');
    }
  }, {
    key: 'isETFHistoricalNAVVIIVChart',
    value: function isETFHistoricalNAVVIIVChart() {
      return _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, 'ETF_HISTORICAL_NAV_VIIV');
    }
  }, {
    key: 'isShowingCurrencyInYAxis',
    value: function isShowingCurrencyInYAxis() {
      return !(0, _functional_utility.isNilOrEmpty)(this.props.fund.visibleData.visibleCharts) && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HISTORICAL_CHART_Y_AXIS_CURRENCY');
    }
  }, {
    key: 'isDistributingVNAV',
    value: function isDistributingVNAV() {
      return !(0, _functional_utility.isNilOrEmpty)(this.props.fund.visibleData.visibleCharts) && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, 'DISTRIBUTING_VNAV');
    }
  }, {
    key: 'isDistributingLVNAVOrCNAV',
    value: function isDistributingLVNAVOrCNAV() {
      return !(0, _functional_utility.isNilOrEmpty)(this.props.fund.visibleData.visibleCharts) && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, 'DISTRIBUTING_LVNAV_CNAV');
    }
  }, {
    key: 'setFilteredData',
    value: function setFilteredData(fromDate, toDate) {

      var normalizedFromDate = _moment2.default.utc((0, _moment2.default)(fromDate.toDate()).startOf('date'));
      var normalizedToDate = _moment2.default.utc((0, _moment2.default)(toDate.toDate()).endOf('date'));

      return _collection_utility.CollectionUtility.filter(this.props.historicalNAVList, function (performance) {
        return _moment2.default.utc((0, _moment2.default)(performance.date)).isBetween(normalizedFromDate, normalizedToDate, null, '[]');
      });
    }
  }, {
    key: 'getMonthAndYearDropdowns',
    value: function getMonthAndYearDropdowns() {
      var _this3 = this;

      var years = [];
      for (var i = this.minDate.year(); i <= this.maxDate.year(); i++) {
        years.push(_react2.default.createElement(
          'option',
          { value: i, 'data-testId': this.props.id + '-year-dropdown-' + i,
            id: 'historical-nav-year-dropdown-' + i },
          i
        ));
      }

      return function (_ref) {
        var month = _ref.month,
            onMonthSelect = _ref.onMonthSelect,
            onYearSelect = _ref.onYearSelect;
        return _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center' } },
          _react2.default.createElement(
            'div',
            { 'data-testId': _this3.props.id + '-month-dropdown', id: 'historical-nav-month-dropdown' },
            _react2.default.createElement(
              'select',
              {
                value: month.month(),
                onChange: function onChange(e) {
                  onMonthSelect(month, e.target.value);
                }
              },
              _moment2.default.monthsShort().map(function (label, value) {
                return _react2.default.createElement(
                  'option',
                  {
                    'data-testId': _this3.props.id + '-month-dropdown-' + value,
                    id: 'historical-nav-month-dropdown-' + value,
                    value: value },
                  label
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { 'data-testId': _this3.props.id + '-year-dropdown', id: 'historical-nav-year-dropdown' },
            _react2.default.createElement(
              'select',
              {
                value: month.year(),
                onChange: function onChange(e) {
                  onYearSelect(month, e.target.value);
                }
              },
              years
            )
          )
        );
      };
    }
  }, {
    key: 'addYearMapsToDateRangeArray',
    value: function addYearMapsToDateRangeArray(dateRangeArray, yearMapArray) {
      var index = void 0;
      for (index = 0; index < yearMapArray.length; index++) {
        if ((0, _moment2.default)(this.maxDate).diff((0, _moment2.default)(this.minDate), 'year') >= yearMapArray[index].years) {
          dateRangeArray.push({
            value: yearMapArray[index].value,
            displayValue: 'Last ' + yearMapArray[index].years + ' year' + (yearMapArray[index].years > 1 ? 's' : ''),
            translationKey: 'dropdown-last-' + yearMapArray[index].years + '-year' + (yearMapArray[index].years > 1 ? 's' : '')
          });
        }
      }
    }
  }, {
    key: 'getDateRangeArray',
    value: function getDateRangeArray() {
      var dateRangeArray = [];
      var yearMapArray = [];

      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_TW_DATE_RANGE_DROP_DOWN')) {
        yearMapArray = [{ years: 1, value: '12' }, { years: 3, value: '36' }, { years: 5, value: '60' }, { years: 10, value: '120' }, { years: 15, value: '180' }];
      } else {
        yearMapArray = [{ years: 1, value: '12' }, { years: 2, value: '24' }, { years: 5, value: '60' }, { years: 10, value: '120' }];
      }

      if (this.isETFHistoricalNAVMarketPriceChart()) {
        dateRangeArray.push({
          value: '0',
          displayValue: 'Since listing date',
          translationKey: 'since-listing-date'
        });
        this.addQuarterAndPreviousYear(dateRangeArray);
      } else {

        dateRangeArray.push({
          value: '0',
          displayValue: 'Since Inception',
          translationKey: 'since-inception'
        });
        this.addYearMapsToDateRangeArray(dateRangeArray, yearMapArray);
      }
      return dateRangeArray;
    }
  }, {
    key: 'dateRangeItems',
    value: function dateRangeItems() {
      var _this4 = this;

      var dateRangeArray = this.getDateRangeArray();

      var count = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_TW_DATE_RANGE_DROP_DOWN') ? 6 : this.state.count;

      var items = mapIndexed(function (dateRangeOption, index) {
        return _this4.generateDateRangeRow(dateRangeOption.value, dateRangeOption.displayValue, dateRangeOption.translationKey, index);
      }, dateRangeArray).slice(0, count);

      items.push(this.generateDateRangeRow("custom", "Custom Date Range", "dropdown-custom-date-range", dateRangeArray.length));
      return items;
    }
  }, {
    key: 'addQuarterAndPreviousYear',
    value: function addQuarterAndPreviousYear(dateRangeArray) {
      var historicalNAVList = this.props.historicalNAVList;

      var findNodeWithPeriodType = function findNodeWithPeriodType(periodTypeCode) {
        return (0, _ramda.find)((0, _ramda.propEq)("periodTypeCode", periodTypeCode), historicalNAVList);
      };
      var includesQ1 = findNodeWithPeriodType("Q1");
      var includesQ2 = findNodeWithPeriodType("Q2");
      var includesQ3 = findNodeWithPeriodType("Q3");
      var includesPY = findNodeWithPeriodType("PY");
      var arr = [includesQ3, includesQ2, includesQ1, includesPY];
      var currentYear = "";
      arr.forEach(function (item) {
        if (!(0, _ramda.isNil)(item) && item.periodTypeCode !== "PY") {
          currentYear = (0, _date_formatter3.getFullYear)(item.date);
        }
      });
      var previousYear = !(0, _ramda.isNil)((0, _ramda.last)(arr)) && (0, _date_formatter3.getFullYear)((0, _ramda.last)(arr).date);
      var displayValueMap = {
        "PY": _string_utility2.default.getLocalizedString(this.props.intl, 'Prior Year {year} (Jan 1 - Dec 31)', 'etf-nav-market-price-year-PY', {}).replace('{year}', previousYear),
        "Q1": _string_utility2.default.getLocalizedString(this.props.intl, 'Q1 {year} (Jan 1 – Mar 31)', 'etf-nav-market-price-year-Q1', {}).replace('{year}', currentYear),
        "Q2": _string_utility2.default.getLocalizedString(this.props.intl, 'Q2 {year} (Apr 1 – Jun 30)', 'etf-nav-market-price-year-Q2', {}).replace('{year}', currentYear),
        "Q3": _string_utility2.default.getLocalizedString(this.props.intl, 'Q3 {year} (Jul 1 – Sep 30)', 'etf-nav-market-price-year-Q3', {}).replace('{year}', currentYear)
      };

      for (var i = 0; i < arr.length; i++) {
        if (!(0, _ramda.isNil)(arr[i]) && arr[i].periodTypeCode !== arr[i].currentQuarter) {
          var periodTypeCode = arr[i].periodTypeCode;
          dateRangeArray.push({
            value: periodTypeCode,
            displayValue: displayValueMap[periodTypeCode],
            translationKey: 'etf-nav-market-price-' + periodTypeCode
          });
        }
      }
    }
  }, {
    key: 'generateDateRangeRow',
    value: function generateDateRangeRow(value, displayValue, translationKey, key) {
      var _this5 = this;

      this[value + 'dropdown'] = _react2.default.createRef();
      var isLastElement = value === "custom";
      return _react2.default.createElement(
        'div',
        { key: key,
          tabIndex: 0,
          'data-option-value': value,
          'data-translation-key': translationKey,
          'data-display-value': displayValue,
          ref: this[value + 'dropdown'],
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleDropdownEvents(_this5, event, '#card-component-' + _this5.props.id + ' #dateRangeFilter', value + 'dropdown', '0dropdown', isLastElement, function () {
              return _this5.setDateFilter(event);
            });
          },
          onClick: this.setDateFilter, className: 'dropdown-list-item', role: 'option' },
        _react2.default.createElement(
          'span',
          { className: 'font-light caption', 'data-option-value': value,
            'data-translation-key': translationKey, 'data-display-value': displayValue },
          _string_utility2.default.renderFormattedLabel(displayValue, translationKey)
        )
      );
    }
  }, {
    key: 'setDateFilter',
    value: function setDateFilter(event) {
      var _this6 = this;

      var filteredData = void 0;
      var toDate = void 0;
      var fromDate = void 0;

      var target = (0, _ramda.isNil)(event.target.getAttribute('data-option-value')) ? event.target.parentNode : event.target;

      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": "pdp",
        "eventAction": "historical price",
        "eventLabel": target.getAttribute("data-display-value")
      });

      if (target.getAttribute("data-option-value") === 'custom') {
        toDate = getDateFromObject((0, _ramda.last)(this.props.historicalNAVList));
        if (this.state.selectedDateOptionValue === 0) {
          fromDate = getDateFromObject(this.props.historicalNAVList[0]);
        } else {
          fromDate = _moment2.default.utc(toDate).subtract(Number(this.state.selectedDateOptionValue), 'months');
        }
        fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(fromDate, "YYYY-MM-DD"));
        toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(toDate, "YYYY-MM-DD"));
        this.setState({
          selectedDateOption: target.getAttribute("data-display-value"),
          selectedDateOptionTranslateKey: target.getAttribute("data-translation-key"),
          toDate: toDate,
          validToDate: toDate,
          fromDate: fromDate,
          validFromDate: fromDate,
          selectedDateOptionValue: "custom"
        });
      } else if ((0, _ramda.includes)("etf-nav-market-price", target.getAttribute("data-translation-key"))) {
        filteredData = (0, _ramda.filter)(function (node) {
          return node.periodTypeCode === target.getAttribute("data-option-value");
        }, this.props.historicalNAVList);
        fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject(filteredData[0]), "YYYY-MM-DD"));
        toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(filteredData)), "YYYY-MM-DD"));
        this.setState({
          filteredData: filteredData,
          fromDate: fromDate,
          toDate: toDate,
          validToDate: toDate,
          validFromDate: fromDate,
          selectedDateOption: target.getAttribute("data-display-value"),
          selectedDateOptionTranslateKey: target.getAttribute("data-translation-key"),
          error: "moderate",
          errorId: null
        }, function () {
          _this6.props.tooltip.closeTooltip();
        });
      } else {
        var dateOption = Number(target.getAttribute("data-option-value"));
        toDate = getDateFromObject((0, _ramda.last)(this.props.historicalNAVList));
        var numberOfYears = (0, _ramda.cond)([[(0, _ramda.equals)(0), (0, _ramda.always)(0)], [(0, _ramda.equals)(12), (0, _ramda.always)(1)], [(0, _ramda.equals)(24), (0, _ramda.always)(2)], [(0, _ramda.equals)(36), (0, _ramda.always)(3)], [(0, _ramda.equals)(60), (0, _ramda.always)(5)], [(0, _ramda.equals)(120), (0, _ramda.always)(10)], [(0, _ramda.equals)(180), (0, _ramda.always)(15)], [(0, _ramda.equals)(240), (0, _ramda.always)(20)]])(dateOption);
        var performanceFromDate = numberOfYears === 0 ? getDateFromObject(this.props.historicalNAVList[0]) : subtractYears(getDateFromObject((0, _ramda.last)(this.props.historicalNAVList)), numberOfYears);
        if (dateOption === 0) {
          fromDate = getDateFromObject(this.props.historicalNAVList[0]);
          filteredData = _collection_utility.CollectionUtility.clone(this.props.historicalNAVList);
        } else {
          fromDate = _moment2.default.utc(toDate).subtract(dateOption, 'months');
          filteredData = this.getFilteredData(dateOption);
        }
        fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(fromDate, "YYYY-MM-DD"));
        toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(toDate, "YYYY-MM-DD"));

        this.setState({
          selectedDateOptionValue: dateOption,
          selectedDateOption: target.getAttribute("data-display-value"),
          selectedDateOptionTranslateKey: target.getAttribute("data-translation-key"),
          filteredData: filteredData,
          toDate: toDate,
          validToDate: toDate,
          fromDate: fromDate,
          validFromDate: fromDate,
          performanceFromDate: performanceFromDate,
          performanceToDate: getDateFromObject((0, _ramda.last)(this.props.historicalNAVList)),
          error: "moderate",
          errorId: null
        }, function () {
          _this6.props.tooltip.closeTooltip();
        });
      }
    }
  }, {
    key: 'getFilteredData',
    value: function getFilteredData(dateOption) {
      var latestMonthEnd = getDateFromObject((0, _ramda.last)(this.props.historicalNAVList));
      var filteredDate = _moment2.default.utc(latestMonthEnd).subtract(Number(dateOption), 'months');
      return _collection_utility.CollectionUtility.filter(this.props.historicalNAVList, function (performance) {
        return performance.epochDate >= filteredDate;
      });
    }
  }, {
    key: 'renderDateRangeDropdown',
    value: function renderDateRangeDropdown() {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_DATE_RANGE_DROP_DOWN') || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_TW_DATE_RANGE_DROP_DOWN')) {
        return _react2.default.createElement(_date_range_dropdown2.default, {
          additionalClassName: this.isETFHistoricalNAVMarketPriceChart() ? "width-percent-25" : "",
          dateRangeItems: this.dateRangeItems,
          setRef: this.setRef,
          parentProps: this.props,
          state: this.state
        });
      }

      return null;
    }
  }, {
    key: 'breakpointIsBetweenOneAndThree',
    value: function breakpointIsBetweenOneAndThree() {
      return this.props.breakpoint === 1 || this.props.breakpoint === 2 || this.props.breakpoint === 3;
    }
  }, {
    key: 'renderCustomDatePickers',
    value: function renderCustomDatePickers() {
      var _this7 = this;

      var _props$fund = this.props.fund,
          numberFormat = _props$fund.numberFormat,
          visibleData = _props$fund.visibleData;

      var dateFormat = "DD/MM/YYYY";

      if (numberFormat === "european") {
        dateFormat = "DD.MM.YYYY";
      }
      if (_collection_utility.CollectionUtility.includes((0, _functional_utility.pathOrEmptyArray)(["formattingRules"], visibleData), 'HISTORICAL_NAV_CHART_DATE_FORMAT_DD_MM_YYYY')) {
        dateFormat = "DD/MM/YYYY";
      } else if (_collection_utility.CollectionUtility.includes((0, _functional_utility.pathOrEmptyArray)(["visibleCharts"], visibleData), 'ETF_HISTORICAL_NAV_MARKET_PRICE')) {
        dateFormat = "MM/DD/YYYY";
      } else if (_collection_utility.CollectionUtility.includes((0, _functional_utility.pathOrEmptyArray)(["formattingRules"], visibleData), 'HISTORICAL_NAV_CHART_DATE_FORMAT_YYYY_MM_DD')) {
        dateFormat = "YYYY/MM/DD";
      }

      return _react2.default.createElement(
        'div',
        { className: 'display-inline' },
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-0 margin-right-10 text-top', 'data-testid': 'from-date-picker' },
          _react2.default.createElement(
            'div',
            {
              className: 'margin-bottom-5 tag-2' + (this.breakpointIsBetweenOneAndThree() ? ' margin-top-5' : ''), role: 'label', id: 'From' },
            _string_utility2.default.renderFormattedLabel("FROM", "pdp-perf-chart-date-from-label")
          ),
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', style: { 'lineHeight': '1.25' } },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              {
                id: 'from-dropdown',
                ref: 'from_dropdown_ref',
                key: 'FROM',
                onClose: function onClose() {
                  _this7.resetErrorState();
                }
              },
              _react2.default.createElement(_single_date_picker_wrapper2.default, {
                date: this.state.fromDate,
                minDate: this.minDate,
                maxDate: (0, _moment2.default)(this.maxDate).format("YYYY-MM-DD"),
                onChangeDate: this.onChangeFromDate,
                onFocusChangeCallback: function onFocusChangeCallback() {
                  _this7.setCustomDateRangeDropdown();
                },
                id: this.props.id + "-from-date",
                dateFormat: dateFormat,
                renderMonthElement: this.getMonthAndYearDropdowns(),
                ariaLabel: "From Date"
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-0 margin-right-10 text-top', 'data-testid': 'to-date-picker' },
          _react2.default.createElement(
            'div',
            {
              className: 'margin-bottom-5 tag-2' + (this.breakpointIsBetweenOneAndThree() ? ' margin-top-5' : ''), role: 'label', id: 'To' },
            _string_utility2.default.renderFormattedLabel("TO", "pdp-perf-chart-date-to-label")
          ),
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', style: { 'lineHeight': '1.25' } },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              {
                id: 'to-dropdown',
                ref: 'to_dropdown_ref',
                key: 'TO',
                onClose: function onClose() {
                  _this7.resetErrorState();
                }
              },
              _react2.default.createElement(_single_date_picker_wrapper2.default, {
                date: this.state.toDate,
                minDate: (0, _moment2.default)(this.minDate).add(1, 'day').format("YYYY-MM-DD"),
                maxDate: (0, _moment2.default)(this.maxDate).add(1, 'day'),
                onChangeDate: this.onChangeToDate,
                onFocusChangeCallback: function onFocusChangeCallback() {
                  _this7.setCustomDateRangeDropdown();
                },
                id: this.props.id + "-to-date",
                dateFormat: dateFormat,
                renderMonthElement: this.getMonthAndYearDropdowns(),
                ariaLabel: "To Date"
              })
            )
          )
        )
      );
    }
  }, {
    key: 'resetErrorState',
    value: function resetErrorState() {
      if (this.state.error === "extreme") {
        this.props.tooltip.closeTooltip();
        this.setState({
          error: "moderate",
          errorId: null,
          fromDate: !(0, _ramda.isEmpty)(this.state.errorMessage) ? this.state.validFromDate : this.state.fromDate,
          toDate: !(0, _ramda.isEmpty)(this.state.errorMessage) ? this.state.validToDate : this.state.toDate,
          errorMessage: ''
        });
      }
    }
  }, {
    key: 'onChangeFromDate',
    value: function onChangeFromDate(fromDate) {
      this.trackDateChange();
      var validToDate = this.state.validToDate;

      var errorMessage = "";

      if ((0, _ramda.isNil)(fromDate) || fromDate.startOf('day').isBefore(this.minDate, "YYYY-MM-DD")) {
        this.handleOutOfRangeDate(this.props.id + "-from-date");
        return false;
      }

      if (fromDate.isAfter(validToDate)) {
        errorMessage = "pdp-historical-chart-error-message-prior-to-to-date";
      } else if (fromDate.isSame(validToDate)) {
        errorMessage = "pdp-historical-chart-error-message-from-date-same-as-to-date";
      }
      this.validateDate(errorMessage, fromDate, validToDate, this.props.id + "-from-date");
    }
  }, {
    key: 'onChangeToDate',
    value: function onChangeToDate(toDate) {
      this.trackDateChange();
      var validFromDate = this.state.validFromDate;

      var errorMessage = "";

      if ((0, _ramda.isNil)(toDate) || toDate.startOf('day').isAfter(this.maxDate)) {
        this.handleOutOfRangeDate(this.props.id + "-to-date");
        return false;
      }

      if (toDate.isBefore(validFromDate, "YYYY-MM-DD")) {
        errorMessage = "pdp-historical-chart-error-message-prior-to-from-Date";
      } else if (toDate.isSame(validFromDate, "day") && toDate.isSame(validFromDate, "month") && toDate.isSame(validFromDate, "year")) {
        errorMessage = "pdp-historical-chart-error-message-to-date-same-as-from-date";
      }

      this.validateDate(errorMessage, validFromDate, toDate, this.props.id + "-to-date");
    }
  }, {
    key: 'trackDateChange',
    value: function trackDateChange() {
      _tracking_utility.TrackingUtility.trackEvent({
        'eventCategory': 'pdp',
        'eventAction': 'historical price',
        'eventLabel': 'date range change'
      });
    }
  }, {
    key: 'validateDate',
    value: function validateDate(errorMessage, fromDate, toDate, label) {
      var _this8 = this;

      var filteredData = void 0;
      var validDateRange = (0, _ramda.isEmpty)(errorMessage);

      if (validDateRange) {
        filteredData = this.setFilteredData(fromDate, toDate);
        this.setState({
          fromDate: fromDate,
          validFromDate: fromDate,
          toDate: toDate,
          validToDate: toDate,
          filteredData: filteredData,
          errorMessage: errorMessage
        }, this.props.tooltip.closeTooltip());
      } else {
        this.setState({
          errorMessage: errorMessage
        }, function () {
          return _this8.renderToolTipErrorMessage(label, errorMessage, {
            toolTipWidth: "254px",
            toolTipContentWidth: "100%"
          });
        });
      }
    }
  }, {
    key: 'handleOutOfRangeDate',
    value: function handleOutOfRangeDate(label) {
      var _this9 = this;

      this.setState({
        fromDate: label === this.props.id + '-from-date' ? null : this.state.fromDate,
        toDate: label === this.props.id + '-to-date' ? null : this.state.toDate,
        errorMessage: "pdp-historical-chart-error-message-out-of-range"
      }, function () {
        return _this9.renderToolTipErrorMessage(label, "pdp-historical-chart-error-message-out-of-range", {
          toolTipWidth: "254px",
          toolTipContentWidth: "100%"
        });
      });
    }
  }, {
    key: 'trackChartDownload',
    value: function trackChartDownload() {
      var trackingObject = {
        "eventCategory": "pdp",
        "eventAction": 'historical price',
        "eventLabel": "download chart data"
      };
      _tracking_utility.TrackingUtility.trackEvent(trackingObject);
    }
  }, {
    key: 'renderNavHistoryCard',
    value: function renderNavHistoryCard() {
      var fromDateQuery = (0, _ramda.isNil)(this.state.fromDate) ? "" : this.state.fromDate.format().replace(/T.+/g, "");
      var toDateQuery = (0, _ramda.isNil)(this.state.toDate) ? "" : this.state.toDate.format().replace(/T.+/g, "");
      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=' + this.props.downloadType + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale() + '&fromDate=' + fromDateQuery + '&toDate=' + toDateQuery);

      var title = (0, _functional_utility.isNilOrEmpty)(this.props.headerTitle) ? "Historical Chart" : _string_utility2.default.getLocalizedString(this.props.intl, this.props.headerTitle.props.defaultMessage, this.props.headerTitle.key, { role: this.props.role });

      var yAxisTicks = this.getYAxisTicks();

      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: this.props.id,
          headerTitle: this.props.headerTitle,
          headerTitleId: this.props.headerTitleId,
          headerTitleLabel: this.props.headerTitleLabel,
          breakpoint: this.props.breakpoint,
          disclosureText: this.props.disclosureText,
          placementId: this.props.placementId,
          extraDisclosureText: this.props.extraDisclosureText,
          extraPlacementId: this.props.extraPlacementId,
          headerLabel: this.getMiscInfoLabel()
        },
        _react2.default.createElement(
          'div',
          { 'data-testid': 'customDateRangeComponent', className: 'font-regular tag' },
          this.renderDateRangeDropdown(),
          this.renderCustomDatePickers()
        ),
        _react2.default.createElement(
          'div',
          { 'data-testid': 'historicalPriceChartContainer', id: 'historicalPriceChartContainer', className: 'padding-top-10' },
          _react2.default.createElement(_nav_chart2.default, {
            navData: (0, _ramda.isNil)(this.state.filteredData) ? this.props.historicalNAVList : this.state.filteredData,
            breakpoint: this.props.breakpoint,
            shareClassInceptionDate: this.props.fund.shareClass.shareClassInceptionDate,
            navPriceFieldKey: this.props.dataPointKey,
            currencyCode: this.props.currencyCode,
            useDynamicxAxisIncrements: true,
            decimalPlaces: this.props.decimalPlaces,
            yAxisTicks: yAxisTicks,
            visibleData: this.props.fund.visibleData,
            language: this.props.language,
            numberFormat: this.props.fund.numberFormat,
            dateToStartFromFirstTick: true,
            yAxisFraction: this.getYAxisFraction(yAxisTicks),
            tooltipImpl: this.props.tooltipImpl,
            isFlatMode: this.props.isFlatMode
          }),
          this.isETFHistoricalNAVMarketPriceChart() && _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'tag chart-legend' },
              (0, _legendSquare.createLegendSquare)(_constants.CHART_COLORS.Pink),
              _react2.default.createElement(
                'span',
                { className: 'font-regular', style: { color: "#000000" },
                  'data-testid': 'historical-chart-nav-legend' },
                _string_utility2.default.renderFormattedLabel('Net Asset Value', 'pdp-historical-chart-net-asset-legend')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'tag chart-legend' },
              (0, _legendSquare.createLegendSquare)(_constants.CHART_COLORS.Green),
              _react2.default.createElement(
                'span',
                { className: 'font-regular', style: { color: "#000000" },
                  'data-testid': 'historical-chart-nav-legend' },
                _string_utility2.default.renderFormattedLabel('Market Price', 'pdp-historical-chart-market-price-legend')
              )
            ),
            this.isETFHistoricalNAVVIIVChart() && _react2.default.createElement(
              'div',
              { className: 'tag chart-legend' },
              (0, _legendSquare.createLegendSquare)(_constants.CHART_COLORS.Brown),
              _react2.default.createElement(
                'span',
                { className: 'font-regular', style: { color: "#000000" },
                  'data-testid': 'historical-chart-nav-legend' },
                'VIIV'
              )
            )
          ),
          this.props.id === 'nav-history' ? this.displayLowestHighestText() : null
        ),
        _react2.default.createElement(_button2.default, {
          role: this.props.role,
          dataTest: "download-data",
          downloadURL: excelServiceURL,
          dataTestLink: this.props.id + '-excel-download',
          text: _string_utility2.default.renderFormattedLabel("DOWNLOAD CHART DATA", "pdp-download-chart-data", { role: this.props.role }),
          widerTopMargin: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HISTORICAL_CHART_DOWNLOAD_BUTTON_WITH_WIDER_TOP_MARGIN'),
          additionalClassName: "mobile-full-width",
          callBack: this.trackChartDownload,
          ariaLabel: 'Download Chart Data for ' + title
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.renderNavHistoryCard()
      );
    }
  }, {
    key: 'displayLowestHighestText',
    value: function displayLowestHighestText() {

      if (!_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HISTORICAL_CHART_HISTORICAL_LOW_HIGH')) {
        return null;
      }

      var data = (0, _ramda.isNil)(this.state.filteredData) ? this.props.historicalNAVList : this.state.filteredData;
      var sortedData = (0, _ramda.sortBy)((0, _ramda.prop)('navPrice'))(data);
      var lowest = sortedData[0];
      var highest = sortedData[sortedData.length - 1];

      return _react2.default.createElement(
        'div',
        {
          className: '' + _functional_utility2.default.isTabOrMobileBreakpoint(this.props.breakpoint, "padding-top-10", "padding-bottom-10"),
          style: {
            'display': 'flex',
            'text-align': 'center',
            'align-items': 'center',
            'flex-flow': 'row wrap',
            'justifyContent': 'space-around'
          } },
        _react2.default.createElement(
          'span',
          {
            className: '' + _functional_utility2.default.isTabOrMobileBreakpoint(this.props.breakpoint, "display-inline-block caption font-size-17 font-normal width-percent-100", "text-left caption font-size-17 font-normal margin-left-100"),
            'data-testid': 'historical_chart_lowest_in_the_period', id: 'historical_chart_lowest_in_the_period' },
          _string_utility2.default.renderFormattedLabel("LOWEST NAV IN THE PERIOD: {nav}", "pdp-historical-card-lowest-nav", { nav: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(lowest.navPrice, this.props.decimalPlaces)) })
        ),
        _react2.default.createElement(
          'span',
          {
            className: '' + _functional_utility2.default.isTabOrMobileBreakpoint(this.props.breakpoint, "display-inline-block caption font-size-17 font-normal width-percent-100", "text-right float-right caption font-size-17 font-normal margin-right-100"),
            'data-testid': 'historical_chart_highest_in_the_period', id: 'historical_chart_highest_in_the_period' },
          _string_utility2.default.renderFormattedLabel("HIGHEST NAV IN THE PERIOD: {nav}", "pdp-historical-card-highest-nav", { nav: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(highest.navPrice, this.props.decimalPlaces)) })
        )
      );
    }
  }, {
    key: 'getMiscInfoLabel',
    value: function getMiscInfoLabel() {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "HISTORICAL_CHART_SHOW_INCEPTION_DATE")) {
        return _react2.default.createElement(
          'div',
          { className: 'font-small disclaimer font-slate-grey' },
          _react2.default.createElement(
            'div',
            { 'data-testid': 'historical_chart_available_since' },
            _string_utility2.default.renderFormattedLabel("Inception Date: ", "pdp-historical-card-subtitle-1", { role: this.props.role }),
            ' ',
            _date_formatter2.default.getFormattedDateAvailebleHeader(this.props.shareClassLaunchDate)
          )
        );
      }

      if (!_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HISTORICAL_CHART_DENOMINATED_CURRENCY') || !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HISTORICAL_CHART_DATA_AVAILABLE_SINCE')) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'font-small disclaimer font-slate-grey' + _functional_utility2.default.ifMobileBreakpoint(this.props.breakpoint, " padding-left-16", "") },
        _react2.default.createElement(
          'div',
          { 'data-testid': 'historical_chart_denominated_currency', id: 'historical_chart_denominated_currency' },
          _string_utility2.default.renderFormattedLabel(" Denominated Currency: {currencyCode}", "pdp-historical-card-subtitle-1", {
            "currencyCode": _currency_utility2.default.getCurrencyTranslation(this.props.fund.shareClass.currencyCode),
            role: this.props.role
          })
        ),
        _react2.default.createElement(
          'div',
          { 'data-testid': 'historical_chart_available_since', id: 'historical_chart_available_since' },
          _date_formatter2.default.getFormattedDateAvailebleHeader(getDateFromObject(this.props.historicalNAVList[0]))
        )
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !!((0, _ramda.isNil)(nextProps) || (!(0, _ramda.equals)(this.props, nextProps) || !(0, _ramda.equals)(this.state, nextState)) && (nextProps.active === 'historical-price' || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'FLAT_MODE')));
    }
  }, {
    key: 'getYAxisFraction',
    value: function getYAxisFraction(yAxisTicks) {
      if (this.isDistributingVNAV() || this.props.dataPointKey === 'marketNav' || this.isETFHistoricalNAVMarketPriceChart() || this.isETFHistoricalNAVPriceChart()) {
        return null;
      }
      if (this.isDistributingLVNAVOrCNAV()) {
        return 4;
      }
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'HISTORICAL_NAV_CHART_YAXIS_ZERO_DP')) {
        return 0;
      } else {
        var fraction = 2;
        if (yAxisTicks != null && yAxisTicks.length > 2 && Number.isInteger(yAxisTicks[1]) && Number.isInteger(yAxisTicks[0])) {
          fraction = 0;
        }

        return fraction;
      }
    }
  }]);

  return NAVHistoryChartParent;
}(_react2.default.Component);

exports.default = NAVHistoryChartParent;